export enum ComponentOwnershipFields {
  CODE = 'componentCd',
  COMPONENT = 'componentName',
  VERSION = 'versionNbr',
  DESCRIPTION = 'componentDescription',
  ON_PREM_GKE = 'onPremGkeCd',
  EMPLOYEE_CUSTOMER = 'employeeCustomerFacingCd',
  COMPONENT_TYPE = 'componentTypeCd',
  TECHNOLOGY_LIST = 'technologyList',
  TEAM = 'owningTeam',
  LEADERSHIP_ID = 'executiveLeadershipEmployeeId',
  PRODUCT_OWNER_ID = 'owningTeamManagerEmployeeId',
  TECH_LEAD_ID = 'owningTeamTechLeadEmployeeId',
  ARCHITECT_ID = 'architectEmployeeId',
  PLATFORM_ENG_ID = 'platformEngineerEmployeeId',
  LEADERSHIP_NAME = 'executiveLeadershipEmployeeName',
  PRODUCT_OWNER_NAME = 'owningTeamManagerEmployeeName',
  TECH_LEAD_NAME = 'owningTeamTechLeadEmployeeName',
  ARCHITECT_NAME = 'architectEmployeeName',
  PLATFORM_ENG_NAME = 'platformEngineerEmployeeName',
  OWNED_TABLE_PREFIX_LIST = 'ownedTablePrefixList',
  APPROVED_INTERFACE_LIST = 'approvedInterfaceList',
  STATUS_CD = 'statusCd',
  SUPER_COMPONENT_CD = 'superComponentCd',
  COMPONENT_LEVEL = 'componentLevel',
  SOX_COMPLIANT_IND = 'soxCompliantInd',
  AUTH_SCOPE_IND = 'authScopeInd',
  SUPPORT_TYPE = 'supportType',
  NOTES = 'notes',
}

export enum ComponentOwnershipLabels {
  CODE = 'Code',
  COMPONENT = 'Component',
  VERSION = 'Version',
  DESCRIPTION = 'Description',
  ON_PREM_GKE = 'On Prem / GKE',
  EMPLOYEE_CUSTOMER = 'Employee / Customer Facing',
  COMPONENT_TYPE = 'Component Type',
  TECHNOLOGY_LIST = 'Technologies (Frameworks)',
  TEAM = 'Team',
  LEADERSHIP_NAME = 'Executive Leadership',
  PRODUCT_OWNER_NAME = 'Product Owner',
  TECH_LEAD_NAME = 'Tech Lead',
  ARCHITECT_NAME = 'Architect',
  PLATFORM_ENG_NAME = 'Platform Eng',
  OWNED_TABLE_PREFIX_LIST = 'Owned Table Prefix',
  APPROVED_INTERFACE_LIST = 'Approved Interface',
  STATUS_CD = 'Status',
  SUPER_COMPONENT_CD = 'Super Component',
  COMPONENT_LEVEL = 'Component Level',
  SOX_COMPLIANT_IND = 'SOX Compliant',
  AUTH_SCOPE_IND = 'Auth Scope',
  SUPPORT_TYPE = 'Support Type',
  NOTES = 'Notes',
}
